// src/models/servicos/TecnicoResponsavel.js
export class TecnicoResponsavel {
  constructor(id = 0, nome = '') {
    this.id = id;
    this.nome = nome;
  }
}
